import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Details({ item, transection_id }) {
  const navigate = useNavigate();
  const getColor = (status) => {
    if (status === "rejected") return "error";
    if (status === "approved") return "success";
    if (status === "pending") return "info";
    if (status === "queued") return "warning";
    if (status === "complete") return "success";
    if (status === "error") return "error";
    if (status === "Abnormal Request") return "error";
    if (status === "not-required") return "warning";
    return "secondary";
  };
  const { t, i18n } = useTranslation();
  return (
    <div className="eligibility_details_section border border-slate-200 !rounded-lg overflow-hidden">
      <div
        className={`${item?.site_eligibility === "eligible" ? "bg-green-500" : "bg-red-500"} p-1 px-2 text-white flex justify-between items-center print:!bg-transparent print:!text-black print:!border-b print:!border-gray-300`}
      >
        <div className="flex space-x-2">
          <div
            className="cursor-pointer flex items-center justify-center w-5 h-5 rounded-full transition-all hover:bg-[#0022aa] active:scale-90 no-print"
            onClick={() => navigate(-1)}
            style={{ backgroundColor: "#0070C2" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              className={`\${
                  i18n.language === "ar" ? "transform rotate-180" : ""
                }`}
            >
              <path
                d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                fill="white"
              ></path>
            </svg>
          </div>
          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide">
              {t("Eligibility Details")}
            </h2>
            <p className="text-[10px] opacity-80 font-mono">
              Transection ID : {transection_id || "---"}
            </p>
          </div>
        </div>
        <div className="text-[10px] font-bold uppercase bg-white/20 px-2 py-0.5 rounded border border-white/30 print:!border-gray-400 print:!text-black">
          {t(item?.site_eligibility) || "---"}
        </div>
      </div>
      <div className="eligibility_details_head !rounded-lg">
        {item?.errors?.map((el, index) => (
          <div className="sm:col-span-6" key={index}>
            <div className="my-1 p-2 text-sm text-red-800 rounded-lg bg-red-50 dark:text-red-400">
              <span className="font-medium">Error {el?.error_code} : </span>
              {el?.error_message}
            </div>
          </div>
        ))}

        <div className="flex flex-col gap-2 p-3 bg-white">
          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-x-2 gap-y-3">
            {[
              { label: t("Beneficiary Name"), value: item?.patient_name },
              { label: t("Document"), value: item?.document_id },
              { label: t("Site Eligibility"), value: item?.site_eligibility },
              { label: t("Identity ID"), value: item?.verification_id },
              {
                label: t("Outcome"),
                value: item?.outcome ? (
                  <Chip
                    label={t(item?.outcome)}
                    color={getColor(item?.outcome)}
                    size="small"
                    className="uppercase !text-white !text-[9px] !h-5 !font-bold"
                    style={{ color: "white !important" }}
                  />
                ) : null,
              },
              {
                isSwitch: true,
                label: t("Is New Born"),
                checked: item?.is_new_born || false,
              },
              {
                isSwitch: true,
                label: t("Is Referral"),
                checked: item?.is_referral || false,
              },
              { label: t("Purpose"), value: item?.purpose },
            ].map((detail, index) => (
              <div key={index} className="eligibility_details_user_data">
                <div className="data_head !text-left !mb-0.5">
                  <span className="!text-gray-500 !text-[12px] font-semibold uppercase tracking-tight">
                    {detail.label}
                  </span>
                </div>
                {detail.isSwitch ? (
                  <div className="data_cont !text-left mt-0.5">
                    <label className="switch transform scale-[0.6] origin-left -ml-1 inline-block">
                      <input
                        type="checkbox"
                        checked={detail.checked}
                        readOnly
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                ) : detail.label === t("Outcome") ? (
                  <div className="mt-0.5 flex items-center h-[20px]">
                    {detail.value || (
                      <span className="!text-gray-400">___</span>
                    )}
                  </div>
                ) : (
                  <div className="data_cont !text-left mt-0.5 leading-tight">
                    <span
                      className={`!text-[12px] !font-bold break-words ${
                        detail.label === t("Site Eligibility")
                          ? "!text-green-700"
                          : "!text-[#0070C2]"
                      }`}
                    >
                      {detail.value || (
                        <span className="!text-gray-400">___</span>
                      )}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-2 gap-y-3">
            {[
              { label: t("Insurer"), value: item?.payer_name },
              { label: t("TPA Name"), value: item?.tpa_name },
              { label: t("Disposition"), value: item?.disposition },
              {
                label: t("Eligibility Response Identifier (Value)"),
                value: item?.verification_resp_ident_value,
              },
            ].map((detail, index) => (
              <div key={index} className="eligibility_details_user_data">
                <div className="data_head !text-left !mb-0.5">
                  <span className="!text-gray-500 !text-[12px] font-semibold uppercase tracking-tight">
                    {detail.label}
                  </span>
                </div>
                <div className="data_cont !text-left mt-0.5 leading-tight">
                  <span className="!text-[#0070C2] !text-[12px] !font-bold break-words">
                    {detail.value || (
                      <span className="!text-gray-400">___</span>
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Details;
